import {AxiosResponse, CancelToken} from 'axios';
import {EntityMedia} from '../backend/interfaces/entity-media';
import {PatchEntityMedia} from '../backend/requests/patch-entity-media';
import {PostEntityMedia} from '../backend/requests/post-entity-media';
import {BackendApiManager} from '../managers/backend-api';
import {Logger} from '../utils/managers/logger';

export class EntityMediaRepository {
  // Singleton Instance
  private static _instance: EntityMediaRepository;

  // Private
  private logger: Logger;

  static get instance(): EntityMediaRepository {
    if (!this._instance) {
      this._instance = new EntityMediaRepository();
    }
    return this._instance;
  }

  constructor() {
    // Create Logger
    this.logger = new Logger('EntityMediaRepository');
  }

  // Get an entity media by id
  public async getById(id: string): Promise<EntityMedia> {
    // Get entity media from backend
    const result: AxiosResponse<EntityMedia> = await BackendApiManager.instance.get<EntityMedia>(
      `/entity-media/${id}`
    );

    // Return
    return result.data;
  }

  // Update the data of an entity media
  public async updateDataById(id: string, body: PatchEntityMedia): Promise<EntityMedia> {
    // Update the entity media data
    const result: AxiosResponse<EntityMedia> = await BackendApiManager.instance.patch<EntityMedia>(
      `/entity-media/${id}`,
      body
    );

    // Return
    return result.data;
  }

  // Delete an entity media
  public async deleteById(id: string): Promise<void> {
    // Delete the entity media
    await BackendApiManager.instance.delete<void>(`/entity-media/${id}`);
  }

  // Create an entity media
  public async create(body: PostEntityMedia): Promise<EntityMedia> {
    // Create the entity media
    const response: AxiosResponse<EntityMedia> = await BackendApiManager.instance.post<EntityMedia>(
      '/entity-media',
      body
    );

    // Return
    return response.data;
  }

  // Get all entity media associated with an entity
  public async getInEntity(
    entityId: string,
    limit: number,
    skip: number,
    cancelToken?: CancelToken
  ): Promise<{totalCount: number; data: Array<EntityMedia>}> {
    // Get entity media from backend
    const response: AxiosResponse<Array<EntityMedia>> = await BackendApiManager.instance.get<
      Array<EntityMedia>
    >(`/entity-media?skip=${skip}&limit=${limit}&entityId=${entityId}`, {cancelToken});

    // Return
    return {
      data: response.data,
      totalCount: parseInt(response.headers['x-total-count'] || '', 10),
    };
  }
}
